import {
  UPDATE_ACCOUNT,
  CHANGE_PASSWORD,
  DELETE_ACCOUNT,
  GET_COUNTRIES,
  GET_CITIES,
  UPDATE_USER_AVATAR,
} from './types';

export const updateAccount = (payload) => ({
  type: UPDATE_ACCOUNT,
  payload,
});

export const updateAvatar = (payload) => ({
  type: UPDATE_USER_AVATAR,
  payload,
});

export const changePassword = (payload) => ({
  type: CHANGE_PASSWORD,
  payload,
});

export const deleteAccount = (payload) => ({
  type: DELETE_ACCOUNT,
  payload,
});

export const getCountries = (payload) => ({
  type: GET_COUNTRIES,
  payload,
});

export const getCities = (payload) => ({
  type: GET_CITIES,
  payload,
});
